import Container from '@/components/atoms/Container'
import Icon from '@/components/atoms/Icon'
import { NODE_ENV } from '@/constants/api'
import { webhookRepository } from '@/repositories'
import { useAppSelector } from '@/store/hooks'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Navigate, useLocation } from 'react-router-dom'
interface AuthProps {
	children: React.ReactNode
}

export function AuthWhiteLabelLayout({ children }: AuthProps) {
	const {
		auth: { signed },
	} = useAppSelector((state) => state)

	const location = useLocation()

	let domain = window.location.hostname

	if (NODE_ENV && ['development'].includes(NODE_ENV)) {
		domain = 'teste.fluencyacademy.co'
	}

	const [_getCompany, { data: company, isLoading, isError }] =
		webhookRepository.useLazyGetByUrlQuery()

	useEffect(() => {
		if (domain) _getCompany({ url: domain })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [domain])

	if (signed) {
		return <Navigate to='/' state={{ redirect: location.pathname }} />
	}

	return (
		<div className='flex flex-col min-h-screen bg-zinc-950 items-center justify-center'>
			<Container className='flex z-10 justify-center items-center'>
				<div className='w-full mb-20 gap-8 max-w-[450px] flex flex-col items-center justify-center'>
					<Link to='/' className='cursor-pointer'>
						{(() => {
							if (isLoading && !company) return <></>

							if (company && company?.logo && company?.white_label) {
								return (
									<div className='relative flex justify-center items-center w-[150px] my-4 md:my-5'>
										<img
											src={company.logo}
											alt='Logo company'
											className='w-full h-full'
										/>
									</div>
								)
							}

							if (isError) {
								return (
									<Icon
										name='logo'
										width='150'
										height='55'
										className='w-[150px] h-auto text-zinc-50'
									/>
								)
							}
						})()}
					</Link>
					<div className='w-full mb-28 gap-12 p-8 bg-zinc-900 flex flex-col rounded-2xl border border-zinc-800'>
						<div className='flex flex-col gap-2'>
							<h1 className='font-bold text-[32px] leading-[110%] text-zinc-50'>
								Olá, estudante!
							</h1>
							<p className='text-sm leading-[110%] text-zinc-50'>
								Acesse a plataforma utilizando seu email corporativo.
							</p>
						</div>
						{children}
					</div>
				</div>
			</Container>
		</div>
	)
}
